import { Flex, Text, Card } from '@/app/ui';
import Colors from '@/app/styles/Colors';

export interface SubscriptionInfo {
  title: string;
  price: number;
  priceId?: string;
  description: string;
  prices: {
    priceId: string;
    price: number;
    interval: string;
    intervalCount: number;
  }[];
}

interface SubscriptionCardProps {
  info: SubscriptionInfo;
  select?: (priceId: string) => void;
}

const SubscriptionCard = ({ info, select }: SubscriptionCardProps) => (
  <Card.Container
    backgroundColor={Colors.white}
    borderStyle="solid"
    borderSize={1}
    borderColor={Colors.grey3}
    style={{ height: '100%', padding: '3rem' }}
  >
    <Card.Body
      style={{
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between',
        height: '100%',
      }}
    >
      <Flex.Container flexDirection="column">
        <Text.Title2 style={{ fontStyle: 'italic' }}>{info.title}</Text.Title2>

        <Text.Paragraph fontSize={14}>{info.description}</Text.Paragraph>
        {info.prices.map(({ priceId, price, interval, intervalCount }) => (
          <Flex.Container key={priceId} alignItems="flex-start" className="mt-4">
            {/* <Icon.CheckIcon width={15} className="mt-1 mr-2" /> */}
            <Flex.Container alignItems="flex-start" flexDirection="column">
              <Text.Paragraph
                className="pt-0"
                fontSize={16}
                fontWeight={500}
                onClick={() => select?.(priceId)}
                style={{ cursor: 'pointer', color: Colors.primary, fontWeight: 600 }}
              >
                <b>{price}€</b>/{intervalCount > 1 ? `${intervalCount} ${interval}` : interval}
              </Text.Paragraph>
            </Flex.Container>
          </Flex.Container>
        ))}
      </Flex.Container>
    </Card.Body>
  </Card.Container>
);

export default SubscriptionCard;
